<template>
  <div>
    <v-alert v-if="message" :type="message.type" dismissible dense>
      {{ message.value }}
    </v-alert>
    <div style="position: relative;">
      <Loader :loading="loading"/>
      <v-row >
        <v-col cols="12" v-if="companies">
          <div>
            <h2>Potencjalnie zainteresowane firmy</h2>
          </div>
          <data-table
              v-model="selected"
              :headers="headers"
              :items="companies"
              :item-class="rowClasses"
              class="elevation-1"
              item-key="id"
              show-select
          >
            <template v-slot:item.email="{ item }">
              <v-select v-model="item.selectedEmail" item-value="value"
                        item-text="text" :items="item.emails">
              </v-select>
            </template>
            <template v-slot:item.name="{ item }">
              <span :style="'background:' + item.color">{{ item.name }}</span>
            </template>
            <template v-slot:item.city="{ item }">
              {{ item.address.city }}
            </template>
            <template v-slot:item.postCode="{ item }">
              {{ item.address.postalCode }}
            </template>
            <template v-slot:item.actions="{ item }">
              <router-link
                  :to="{name: 'company-details', params: { id: item.id }}"
              >Szczegóły firmy
              </router-link>

            </template>
          </data-table>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
<!--          <PotentiallyInterestedManual-->
<!--              :sale-offer-id="saleOfferId"-->
<!--          />-->
        </v-col>
      </v-row>
      <v-alert
          outlined
          color="deep-orange"
          prominent
          border="left"

          v-if="wmFinancingSaleOfferId"
      >
        <strong>Oferta jest obsługiwana przez Wastemaster. <br>Przejdź do właściwej usługi, która jest widoczna dla klientów i do której należy wysyłać propozycje partnerom.<br>
          <router-link
              :to="{name: 'sale-offer-details', params: { id: wmFinancingSaleOfferId }}"
          >
            Przejdź ...
          </router-link></strong>
      </v-alert>
      <v-row>
        <v-col>
          <div class="mt-5">
            <modal-add-company ref="addCompanyDialog" :refresh="true"/>
            <v-btn @click="showAddCompanyModal" color="blue" class="mb-2" block>Utwórz firmę</v-btn>
            <v-btn @click="send" color="green" block>
              Wyślij ofertę
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import api from '../../services/api';
import Loader from '../Loader';
//import PotentiallyInterestedManual from './PotentiallyInterestedManual';
import formatters from "@/mixins/formatters";
import DataTable from "@/components/data-table/DataTable";
import ModalAddCompany from "@/components/ModalAddCompany.vue";

export default {
  components: {
    ModalAddCompany,
    DataTable,
    Loader,
    //PotentiallyInterestedManual,
  },
  mixins: [formatters],
  props: [
    'saleOfferId',
    'orderId',
    'companiesProp',
    'wmFinancingSaleOfferId'
  ],
  data() {
    return {
      loading: false,
      message: null,
      selected: [],
      selected2: [],
      companies: this.companiesProp,
      headers: [
        {text: 'Nazwa', value: 'name'},
        {text: 'NIP', value: 'nip'},
        {text: 'Miasto', value: 'city'},
        {text: 'Kod pocztowy', value: 'postCode'},
        {text: 'E-mail', value: 'email'},
        {text: 'Telefon', value: 'phone'},
        {text: 'Akcje', value: 'actions'},
      ],
    }
  },
  methods: {
    rowClasses(item) {
      if (item.isRegistered) {
        return 'success';
      }
    },
    async send() {
      this.message = null;

      if (!this.selected.length && !this.selected2.length) {
        const store = {
          allowEmpty: true,
        };
        await this.$root.$emit('getManuallyAddedCompanies', store);

        if (!store.companies.length) {
          this.message = null;
          const self = this;
          setTimeout(function () {
            self.message = {
              type: 'error',
              value: 'Wybierz co najmniej jedną firmę z listy lub dodaj ręcznie nową'
            };
          }, 4);

          return;
        }
      }

      this.loading = true;
      let companies = [];

      for (let company of this.selected) {
        companies.push({
          id: company.id,
          email: typeof company.selectedEmail  === 'object' ? company.selectedEmail.value : company.selectedEmail,
          phone: company.phone,
        })
      }

      try {
        if (this.saleOfferId) {
          await api.post('/api/sale-offers/send-to-potentially-interested', {
            saleOfferId: this.saleOfferId,
            companies: companies
          });
        }

        if (this.orderId) {
          await api.post('/api/orders/send-to-potentially-interested', {
            orderId: this.orderId,
            companies: companies
          });
        }


        this.companiesWithPartner = null;
        this.companiesWithoutPartner = null;
        this.selected = [];

        this.message = {
          type: 'success',
          value: 'Oferta została wysłana'
        };

        await this.$root.$emit('sendToManuallyAddedCompanies');
        this.$emit('sent');
      } catch (e) {
        this.loading = false;
        this.message = {
          type: 'error',
          value: 'Nie udało się wysłać oferty'
        }
      }

      this.loading = false;
    },
    async showAddCompanyModal() {
      this.$refs.addCompanyDialog
          .open()
    },
  },
  watch: {
    companiesProp(data) {
      data = data.map((company) => {
        company.selectedEmail = {value: company.email, text: 'Firmowy - ' + company.email};
        company.emails = [];
        company.emails.push(company.selectedEmail);

        company.users.forEach((user) => {
          if (company.email !== user.email) {
            company.emails.push({value: user.email, text: `${user.name} ${user.surname} - ${user.email} ${user.info}`})
          }
        });

        return company;
      });

      this.companies = data;
    },
  }
}
</script>

<style scoped>

</style>